import {
  CustomerGroupType,
  minimalCustomerGroupSchema,
} from "@redotech/redo-customer-segments-common/customers/customer-group-definition";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const getCustomerGroupsMinimal = {
  name: "getCustomerGroupsMinimal" as const,
  input: z.object({ type: createEnum(CustomerGroupType).optional() }),
  output: z.array(minimalCustomerGroupSchema),
};
